import PropTypes from 'prop-types'
import {Box, Flex} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import LogoQantasBusinessRewards from '~/react/components/Logo/LogoQantasBusinessRewards'
import LogoVirginVelocityFrequentFlyer from '~/react/components/Logo/LogoVirginVelocityFrequentFlyer'
import LogoSingaporeAirlinesKrisFlyer from '~/react/components/Logo/LogoSingaporeAirlinesKrisFlyer'

const PartnerCell = ({getValue}) => {
  const {t} = useTranslation('points')

  const partner = getValue()

  const getPartnerLogo = (partnerKey) => {
    switch (partnerKey) {
      case 'QBR':
        return <LogoQantasBusinessRewards />
      case 'VABF':
        return <LogoVirginVelocityFrequentFlyer />
      case 'KRI':
        return <LogoSingaporeAirlinesKrisFlyer />
      default:
        return (
          <Box
            width="32px"
            height="32px"
            bg="gray.100"
            borderRadius="md"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="xs"
            color="gray.600"
          >
            {partner.name ? partner.name.charAt(0) : '?'}
          </Box>
        )
    }
  }

  return (
    <Flex align="center" gap="sm" py="xs">
      <Box
        width="108px"
        height="54px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        backgroundColor="mld.neutral.50"
        p="xs"
      >
        {getPartnerLogo(partner.key)}
      </Box>
      <Flex flexDirection="column" flexWrap="wrap" gap="xxs">
        <Box fontWeight="500">{partner.name}</Box>
        <Box
          color="mld.neutral.700"
          textStyle="body-detail"
          style={{
            'text-wrap': 'auto',
          }}
        >
          {t(
            `points:redemptionActivitiesScreen.memberStatusFailureMessage.${partner.key}.${partner.memberStatus}`,
            '',
          )}
        </Box>
      </Flex>
    </Flex>
  )
}

PartnerCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default PartnerCell
